import React, { Component, Fragment } from 'react';
import "./toolbar.css";
import Search from "./search"
import Select, { Creatable, Async } from 'react-select';
import classNames from 'classnames';

import { SingleDatePicker } from 'react-dates'
import 'react-dates/initialize';
import moment from 'moment';
import { api } from 'api';
import 'react-dates/lib/css/_datepicker.css';


let estado = [
    {id: 0, value: 0, label: "TODOS"},
    {id: 1, value: 1, label: "ASIGNADOS"},
    {id: 2, value: 2, label: "PENDIENTES"},
    {id: 3, value: 3, label: "ANULADOS"},
]


const getClientes = (search) => {
    return api.get("clientes", { search, esCliente: true }).
        then((data) => {
            if (data) return data.results;
            return [];
        }).catch(() => {
            return [];
        });
};

const getVendedores = (search, props) => {
    let params = {search}
    params.is_active = true

    if (props.permisos && !props.permisos.ver_todo_liquidacion_historial) params.vendedorId = props.idVendedor

    return api.get("liquidaciones/get_usuarios_vendedores_liquidaciones", params).
        then((data) => {
            if (data) return data.results;
            return [];
        }).catch(() => {
            return [];
        });
};

export default class ToolbarRecibosCaja extends Component {
    state = {
        asyncValue: this.props.asyncValue ? this.props.asyncValue : null,
        usuario_aprobacion: null,
        focusedStart: false,
        dateStart: null,
        dateEnd: null,
        focusedEnd: false,
        clientesOptions: null,
        cobradoresOptions: null,
    }

    componentWillMount() {
        const resClientes = getClientes('', this.props)
        resClientes.then((valor) => {
            this.setState({ clientesOptions: valor })
        })

        const resUsuariosAsignaciones = getVendedores('', this.props)
        resUsuariosAsignaciones.then((valor) => {
            this.setState({ cobradoresOptions: valor })
        })
    }

    render() {
        return (
            <div className="row col-12 p-0">
                <div className="row col-12 m-0 text-lg-left">
                    <div className={"col-lg-2 col-md-3 col-12 align-self-center"}>
                        <span className="t-azul-claro font-weight-bold">Fecha Inicial</span>
                        <SingleDatePicker
                            // className="form-control"
                            placeholder={"Fecha Inicio"}
                            // date={this.state.dateStart}
                            date={this.props.fecha_I}
                            focused={this.state.focusedStart}
                            isOutsideRange={() => false}
                            onDateChange={(value) => {
                                this.props.changeRangeDate(value, true, null);
                            }}
                            onFocusChange={({ focused }) => this.setState({ focusedStart: focused })}
                            numberOfMonths={1}
                            showClearDate={true}
                            id={"dateStart"}
                        />
                    </div>
                    <div className={"col-lg-2 col-md-3 col-12 align-self-center"}>
                        <span className="t-azul-claro font-weight-bold">Fecha Final</span>
                        <SingleDatePicker
                            // className="form-control"
                            placeholder={"Fecha Final"}
                            // date={this.state.dateEnd}
                            date={this.props.fecha_F}
                            focused={this.state.focusedEnd}
                            isOutsideRange={() => false}
                            onDateChange={(value) => {
                                this.props.changeRangeDate(value, null, true);
                            }}
                            onFocusChange={({ focused }) => this.setState({ focusedEnd: focused })}
                            numberOfMonths={1}
                            showClearDate={true}
                            id={"dateEnd"}
                        />
                    </div>
                    <div className={"col-lg-3 col-md-3 col-12 align-self-center"}>
                        <span className="t-azul-claro font-weight-bold">Cliente</span>
                        <Async
                            isClearable={true}
                            backspaceRemovesValue={false}
                            value={this.props.cliente}
                            isSearchable={true}
                            loadOptions={getClientes}
                            getOptionValue={(option) => (option["id"])}
                            getOptionLabel={(option) => (option["nombre"])}
                            type="text"
                            onChange={(e) => {
                                e ? this.setState({ cliente: e.id, asyncValue: e ? e : null }) : this.setState({ cliente: null })
                                if (this.props.changeCliente) {
                                    e ? this.props.changeCliente(e) : this.props.changeCliente(null)
                                }
                            }}

                            multi={true}
                            autoload={false}
                            cache={false}
                            className={classNames('react-select-container ')}
                            defaultOptions={this.state.clientesOptions}
                            placeholder="Seleccionar.."
                        />
                    </div>
                    <div className={"col-lg-3 col-md-3 col-12 align-self-center"}>
                        <span className="t-azul-claro font-weight-bold">Cobrador</span>
                        <Async
                            isClearable={true}
                            backspaceRemovesValue={false}
                            isSearchable={true}
                            loadOptions={(search) => getVendedores(search, this.props)}
                            getOptionValue={(option) => (option["id"])}
                            getOptionLabel={(option) => (`${option["first_name"]} ${option["last_name"]}`)}
                            type="text"
                            onChange={(e) => {
                                e ? this.props.changeCobrador(e) : this.props.changeCobrador(null)
                            }}
                            // cacheOptions
                            multi={true}
                            autoload={false}
                            cache={false}
                            className={classNames('react-select-container ')}
                            defaultOptions={this.state.cobradoresOptions}
                            placeholder="Seleccionar.."
                        />
                    </div>
                    <div className={"col-lg-2 col-md-3 col-12 align-self-center"}>
                        <span className="t-azul-claro font-weight-bold">Estado</span>
                        <Select
                            isClearable={false}
                            className={classNames('react-select-container')}
                            backspaceRemovesValue={false}
                            isSearchable={true}
                            options={estado}
                            placeholder={"Estado"}
                            value={this.props.estado}
                            onChange={this.props.estadoChange}
                            />
                    </div>
                    {(this.props.buscar !== undefined) && (
                        <Fragment>
                            <div className="col-lg-9 col-md-9 mt-2 text-right search d-flex align-items-end">
                            </div>
                            <div className="col-lg-3 col-md-3 mt-2 text-right search d-flex align-items-end">
                                <Search buscar={this.props.buscar} buscador={this.props.buscador} placeholder={this.props.placeholder} />
                            </div>
                        </Fragment>
                    )}
                </div>
            </div>
        )
    }
}
